const { CHANNEL_INTERFACE_TYPE } = require('@/enums');

module.exports = (s) => {
  return {
    name: {
      label: '模板名称',
      type: 'label',
      is_filter: true,
      value: '',
    },
    advertiser_id: {
      label: '广告主账户',
      type: 'select',
      props: {
        clearable: false,
        filterable: true,
      },
      options: [],
      value: '',
      rules: { required: true, trigger: ['change'], message: '请选择广告主账户' },
      on: {
        change: () => {
          const { advertiser_id, fusion__channel_code, delivery_platform_type, delivery_content_id } = s.dialog_config.form_config;
          const { fusion__channel_codes } = fusion__channel_code.children;
          const advertiser_options = advertiser_id.options;
          const findLabel = (advertiser_id) => advertiser_options.find((item) => item.value === advertiser_id)?.label || '';
          fusion__channel_codes.value = [advertiser_id.value].map(advertiser_id => {
            return {
              label: findLabel(advertiser_id),
              advertiser_id,
              list: [],
            };
          });
          delivery_content_id.initOps.advertiser_ids = [advertiser_id.value];
          delivery_platform_type.on.change();
        },
      },
    },
    advertiser_source_name: {
      label: '锚点名称',
      type: 'input',
      props: {
        placeholder: '请输入模板名称',
        showWordLimit: true,
        maxlength: 15,
      },
      word_list: ['渠道号'],
      value: '',
      rules: { required: true, trigger: ['change'], message: '请输入锚点名称' },
    },
    fusion__channel_code: {
      label: '渠道号',
      formItemProps: {
        class: ['children-form-widget'],
      },
      children: {
        fusion__channel_code_prefix: {
          label: '渠道号前缀',
          hidden: false,
          rules: {
            required: true,
            message: '请输入渠道号前缀',
            trigger: ['change'],
          },
          props: {
            placeholder: '请输入渠道号前缀',
            style: {
              width: '150px',
              marginRight: '20px',
            },
            class: 'mr-20',
          },
          formItemProps: {
            class: 'pt-0',
          },
          value: '',
        },
        fusion__channel_code_begin_num: {
          label: '渠道起始编号',
          type: 'input-number',
          hidden: false,
          rules: {
            required: true,
            message: '请输入渠道起始编号',
            trigger: ['change'],
          },
          props: {
            step: 1,
            min: 1,
            max: 99999999,
          },
          value: '',
        },
        fusion__channel_code_count: {
          label: '渠道生成数',
          type: 'input-number',
          hidden: false,
          rules: {
            required: true,
            message: '请输入渠道生成数',
            trigger: ['change'],
          },
          props: {
            step: 1,
            min: 1,
            max: 99999999,
          },
          value: '',

        },
        fusion__channel_codes: {
          label: '',
          value: [],
          tabIndex: 0,
          rules: [
            {
              required: true,
              message: '请点击添加渠道',
              trigger: ['change'],
            },
            {
              required: true,
              trigger: ['change'],
              message: '每广告主账户下渠道数需≥1',
              validator: (rule, value, callback) => {
                const valid = value.every(({ list = [] }) => list.length >= 1);
                valid ? callback() : callback(new Error(rule.message));
              },
            },
          ],
          isBox: true,
          formItemTips: {
            props: {
              class: 'color-red',
            },
            content: '注意：一个渠道号对应生成一条内容',
          },
        },
      },
      value: {},
      rules: { required: true, message: '请输入渠道号', trigger: ['change'] },
    },
    delivery_platform_type: {
      label: '投放平台',
      type: 'radio-group',
      isButton: true,
      options: (() => {
        const delivery_platform_type = s.$store.getters[`${CHANNEL_INTERFACE_TYPE.JRTT}Enum`].api_fusion_delivery_platform_type || [];
        const support_delivery_platform_type = ['ANDROID', 'IOS'];
        return delivery_platform_type.filter(({ value }) => support_delivery_platform_type.includes(value));
      })(),
      value: 'ANDROID',
      on: {
        change: () => {
          const { delivery_platform_type, delivery_content_id, android_download_link, ios_download_link } = s.dialog_config.form_config;
          const is_android = delivery_platform_type.value === 'ANDROID';
          const is_ios = delivery_platform_type.value === 'IOS';
          delivery_content_id.value.type_selection = [];
          Object.assign(delivery_content_id.value, {
            type_selection: [
              ...(is_android ? [{ label: 'Android应用', value: 'ANDROID' }] : []),
              ...(is_ios ? [{ label: 'IOS应用', value: 'IOS' }] : []),
            ],
            result_map: {},
          });
          android_download_link.hidden = !is_android;
          ios_download_link.hidden = !is_ios;
          ios_download_link.value = '-';
        },
      },
    },
    delivery_content_id: {
      label: '投放内容',
      type: '',
      is_open: false,
      initOps: {
        advertiser_ids: [],
        channel_interface: CHANNEL_INTERFACE_TYPE.JRTT,
      },
      value: {
        type_selection: [
          { label: 'Android应用', value: 'ANDROID' },
        ],
        result_map: {},
      },
      rules: {
        required: true,
        trigger: ['change'],
        validator: (_, value, callback) => {
          if (Object.keys(value.result_map).length) {
            callback();
          } else {
            callback(new Error('请选择投放内容'));
          }
        },
      },
      on: {
        change: () => {
          const { advertiser_id, delivery_platform_type, delivery_content_id, ios_download_link } = s.dialog_config.form_config;
          const is_ios = delivery_platform_type.value === 'IOS';
          if (is_ios) {
            const { result_map } = delivery_content_id.value;
            const delivery_content = result_map[advertiser_id.value];
            const delivery_content_item = delivery_content.options.find(({ value }) => delivery_content.value === value);
            ios_download_link.value = delivery_content_item.jrtt_params.download_url;
          }
        },
      },
    },
    android_download_link: {
      label: '安卓下载链接',
      type: 'radio-group',
      isButton: true,
      is_filter: true,
      hidden: false,
      options: [
        { label: '安卓下载链接', value: 'android_download_link' },
      ],
      value: 'android_download_link',
    },
    ios_download_link: {
      label: 'ios下载链接',
      type: 'label',
      is_filter: true,
      hidden: true,
      value: '-',
    },
  };
};
